import { Box, Button, Typography } from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { UpgradeDialogSource } from "schemas/dashboard";
import { Plans } from "schemas/payments";

import styles from "./styles";

const VirtualAssistantCard = () => {
  const location = useLocation();
  const { currentOrg } = useContext(OrganizationUserContext);
  const { setUpgradeDialogSource, setOpenCheckoutDialog } =
    useContext(SubscriptionContext);

  if (currentOrg?.isVaUser || currentOrg?.isAutopilotUser) {
    return <></>;
  }

  const isAutopilot = currentOrg?.showAutopilotPlan;

  const checkoutPage = () => {
    setUpgradeDialogSource(UpgradeDialogSource.upgrade_va_button);
    setOpenCheckoutDialog({
      plan: isAutopilot ? Plans.AUTOPILOT_YEARLY : Plans.VA_YEARLY,
      pageSource: location.pathname,
      source: UpgradeDialogSource.upgrade_va_button,
    });
  };

  return (
    <Box sx={styles.cardBg}>
      <Box sx={styles.chip}>
        {isAutopilot ? "👑 Autopilot" : "🔒 AI Virtual Assistant"}
      </Box>
      <Typography variant="h4" sx={{ color: "yellow.main" }} gutterBottom>
        {isAutopilot
          ? "Hands-off pitching for busy creators"
          : "Want a Virtual Assistant to pitch for you?"}
      </Typography>

      <Typography sx={{ color: "#ECEAE5", mb: 2 }}>
        {isAutopilot
          ? "Runs on autopilot so you set it up once and have weekly pitches sent automatically"
          : "300 pitches sent on your behalf (+ 700 self serve emails), no manual work needed"}
      </Typography>

      <Button
        variant="outlined"
        sx={styles.upgradeButton}
        fullWidth
        onClick={checkoutPage}
      >
        {isAutopilot ? "Upgrade to Autopilot" : "Upgrade to unlock VA"}
      </Button>
    </Box>
  );
};

export default VirtualAssistantCard;
